import { defineMessages } from 'react-intl';

export default defineMessages({
  name: {
    id: 'app.common.tableHeaders.name',
    defaultMessage: 'name',
  },
  register: {
    id: 'app.common.tableHeaders.register',
    defaultMessage: 'register',
  },
  memberNOS: {
    id: 'app.common.tableHeaders.memberNOS',
    defaultMessage: 'member/NOS',
  },
  invoiceNumber: {
    id: 'app.common.tableHeaders.invoiceNumber',
    defaultMessage: 'Invoice number',
  },
  overtime: {
    id: 'app.common.tableHeaders.overtime',
    defaultMessage: 'Overtime',
  },
  initialClockIn: {
    id: 'app.common.tableHeaders.initialClockIn',
    defaultMessage: 'Initial Clock In',
  },
  finalClockOut: {
    id: 'app.common.tableHeaders.finalClockOut',
    defaultMessage: 'Final Clock Out',
  },
  duration: {
    id: 'app.common.tableHeaders.duration',
    defaultMessage: 'Duration',
  },
  dayOvertime: {
    id: 'app.common.tableHeaders.dayOvertime',
    defaultMessage: 'Day Overtime',
  },
  events: {
    id: 'app.common.tableHeaders.events',
    defaultMessage: 'Events',
  },
  customer: {
    id: 'app.common.tableHeaders.customer',
    defaultMessage: 'Customer',
  },
  servicedBy: {
    id: 'app.common.tableHeaders.servicedBy',
    defaultMessage: 'Serviced By',
  },
  redeemedBy: {
    id: 'app.reports.redeemedBy',
    defaultMessage: 'Redeemed By',
  },
  inventories: {
    id: 'app.reports.inventories',
    defaultMessage: 'Inventory',
  },
  total: {
    id: 'app.common.tableHeaders.total',
    defaultMessage: 'Total',
  },
  subtotal: {
    id: 'app.common.tableHeaders.subtotal',
    defaultMessage: 'Subtotal',
  },
  discount: {
    id: 'app.common.tableHeaders.discount',
    defaultMessage: 'Discount',
  },
  author: {
    id: 'app.common.tableHeaders.author',
    defaultMessage: 'Author',
  },
  member: {
    id: 'app.common.tableHeaders.member',
    defaultMessage: 'Member',
  },
  redeemed: {
    id: 'app.common.tableHeaders.redeemed',
    defaultMessage: 'Redeemed',
  },
  period: {
    id: 'app.common.tableHeaders.period',
    defaultMessage: 'Period',
  },
  status: {
    id: 'app.common.tableHeaders.status',
    defaultMessage: 'status',
  },
  campaignStatus: {
    id: 'app.common.tableHeaders.campaignStatus',
    defaultMessage: 'campaign status',
  },
  crmStatus: {
    id: 'app.common.tableHeaders.crmStatus',
    defaultMessage: 'crm status',
  },
  remaining: {
    id: 'app.common.tableHeaders.remaining',
    defaultMessage: 'remaining',
  },
  balance: {
    id: 'app.common.tableHeaders.balance',
    defaultMessage: 'balance',
  },
  maxInvoice: {
    id: 'app.common.tableHeaders.maxInvoice',
    defaultMessage: 'max invoice %',
  },
  barcode: {
    id: 'app.common.tableHeaders.barcode',
    defaultMessage: 'barcode',
  },
  amount: {
    id: 'app.common.tableHeaders.amount',
    defaultMessage: 'amount',
  },
  amountPayer: {
    id: 'app.common.tableHeaders.amountPayer',
    defaultMessage: 'Amount Payer',
  },
  amountPayerPercentage: {
    id: 'app.common.tableHeaders.amountPayerPercentage',
    defaultMessage: 'Amount Payer %',
  },
  amountClient: {
    id: 'app.common.tableHeaders.amountClient',
    defaultMessage: 'Amount Client',
  },
  amountClientPercentage: {
    id: 'app.common.tableHeaders.amountClientPercentage',
    defaultMessage: 'Amount Client %',
  },
  created: {
    id: 'app.common.tableHeaders.created',
    defaultMessage: 'Created',
  },
  employee: {
    id: 'app.common.tableHeaders.employee',
    defaultMessage: 'Employee',
  },
  clearedBy: {
    id: 'app.common.tableHeaders.clearedBy',
    defaultMessage: 'Cleared By',
  },
  clubs: {
    id: 'app.common.tableHeaders.clubs',
    defaultMessage: 'Clubs',
  },
  club: {
    id: 'app.common.tableHeaders.club',
    defaultMessage: 'Club',
  },
  clubDue: {
    id: 'app.common.tableHeaders.clubDue',
    defaultMessage: 'Club Due',
  },
  feeDue: {
    id: 'app.common.tableHeaders.feeDue',
    defaultMessage: 'Fee Due',
  },
  amountDue: {
    id: 'app.common.tableHeaders.amountDue',
    defaultMessage: 'Amount Due',
  },
  potentialClub: {
    id: 'app.common.tableHeaders.potentialClub',
    defaultMessage: 'Potential Club',
  },
  paymentOptions: {
    id: 'app.common.tableHeaders.paymentOptions',
    defaultMessage: 'Payment Options',
  },
  perPayment: {
    id: 'app.common.tableHeaders.perPayment',
    defaultMessage: 'Per payment',
  },
  more: {
    id: 'app.common.tableHeaders.more',
    defaultMessage: 'More...',
  },
  homeClub: {
    id: 'app.common.tableHeaders.homeClub',
    defaultMessage: 'home club',
  },
  departments: {
    id: 'app.common.tableHeaders.departments',
    defaultMessage: 'departments',
  },
  payType: {
    id: 'app.common.tableHeaders.payType',
    defaultMessage: 'pay type',
  },
  redeemType: {
    id: 'app.common.tableHeaders.redeemType',
    defaultMessage: 'redeem type',
  },
  condition: {
    id: 'app.common.tableHeaders.condition',
    defaultMessage: 'condition',
  },
  calculation: {
    id: 'app.common.tableHeaders.calculation',
    defaultMessage: 'calculation',
  },
  sound: {
    id: 'app.common.tableHeaders.sound',
    defaultMessage: 'sound',
  },
  edit: {
    id: 'app.common.tableHeaders.edit',
    defaultMessage: 'edit',
  },
  bulkEdit: {
    id: 'app.common.tableHeaders.bulkEdit',
    defaultMessage: 'bulk edit',
  },
  packageType: {
    id: 'app.common.tableHeaders.packageType',
    defaultMessage: 'bundle type',
  },
  employees: {
    id: 'app.common.tableHeaders.employees',
    defaultMessage: 'employees',
  },
  services: {
    id: 'app.common.tableHeaders.services',
    defaultMessage: 'services',
  },
  items: {
    id: 'app.common.tableHeaders.items',
    defaultMessage: 'items',
  },
  rate: {
    id: 'app.common.tableHeaders.rate',
    defaultMessage: 'rate',
  },
  taxes: {
    id: 'app.common.tableHeaders.taxes',
    defaultMessage: 'taxes',
  },
  availability: {
    id: 'app.common.tableHeaders.availability',
    defaultMessage: 'availability',
  },
  left: {
    id: 'app.common.tableHeaders.left',
    defaultMessage: 'left',
  },
  delete: {
    id: 'app.common.tableHeaders.delete',
    defaultMessage: 'DELeTE',
  },
  code: {
    id: 'app.common.tableHeaders.code',
    defaultMessage: 'code',
  },
  location: {
    id: 'app.common.tableHeaders.location',
    defaultMessage: 'location',
  },
  cost: {
    id: 'app.common.tableHeaders.cost',
    defaultMessage: 'cost',
  },
  retail: {
    id: 'app.common.tableHeaders.retail',
    defaultMessage: 'retail',
  },
  rCode: {
    id: 'app.common.tableHeaders.rCode',
    defaultMessage: 'r. code',
  },
  withTax: {
    id: 'app.common.tableHeaders.withTax',
    defaultMessage: 'with tax',
  },
  onHandIdeal: {
    id: 'app.common.tableHeaders.onHandIdeal',
    defaultMessage: 'on hand/ideal',
  },
  reorder: {
    id: 'app.common.tableHeaders.reorder',
    defaultMessage: 'REoRDER',
  },
  vendor: {
    id: 'app.common.tableHeaders.vendor',
    defaultMessage: 'vendor',
  },
  catalog: {
    id: 'app.common.tableHeaders.catalog',
    defaultMessage: 'catalog',
  },
  description: {
    id: 'app.common.tableHeaders.description',
    defaultMessage: 'description',
  },
  taxesTaxBundles: {
    id: 'app.common.tableHeaders.taxesTaxBundles',
    defaultMessage: 'taxes & TaX bundles',
  },
  taxesBundlesTotal: {
    id: 'app.common.tableHeaders.taxesBundlesTotal',
    defaultMessage: 'taxes & bundles total',
  },
  totalRate: {
    id: 'app.common.tableHeaders.totalRate',
    defaultMessage: 'Total rate',
  },
  inUse: {
    id: 'app.common.tableHeaders.inUse',
    defaultMessage: 'in use',
  },
  userId: {
    id: 'app.common.tableHeaders.userId',
    defaultMessage: 'user id',
  },
  id: {
    id: 'app.common.tableLabels.id',
    defaultMessage: 'id',
  },
  phone: {
    id: 'app.common.tableHeaders.phone',
    defaultMessage: 'phone',
  },
  phones: {
    id: 'app.common.tableHeaders.phones',
    defaultMessage: 'phones',
  },
  email: {
    id: 'app.common.tableHeaders.email',
    defaultMessage: 'email',
  },
  emails: {
    id: 'app.common.tableHeaders.emails',
    defaultMessage: 'emails',
  },
  accountNumber: {
    id: 'app.common.tableLabels.accountNumber',
    defaultMessage: 'account number',
  },
  website: {
    id: 'app.common.tableLabels.website',
    defaultMessage: 'website',
  },
  label: {
    id: 'app.common.tableHeaders.label',
    defaultMessage: 'label',
  },
  itemService: {
    id: 'app.common.tableHeaders.itemService',
    defaultMessage: 'item/service',
  },
  qty: {
    id: 'app.common.tableHeaders.qty',
    defaultMessage: 'qty',
  },
  perUnit: {
    id: 'app.common.tableHeaders.perUnit',
    defaultMessage: 'per unit',
  },
  units: {
    id: 'app.common.tableHeaders.units',
    defaultMessage: 'Units',
  },
  unit: {
    id: 'app.common.tableHeaders.unit',
    defaultMessage: 'Unit',
  },
  pricePerBilling: {
    id: 'app.common.tableHeaders.pricePerBilling',
    defaultMessage: 'price per billing',
  },
  payPeriod: {
    id: 'app.common.tableHeaders.payPeriod',
    defaultMessage: 'Pay Period',
  },
  startDate: {
    id: 'app.common.tableHeaders.startDate',
    defaultMessage: 'Start Date',
  },
  endDate: {
    id: 'app.common.tableHeaders.endDate',
    defaultMessage: 'End Date',
  },
  payDate: {
    id: 'app.common.tableHeaders.payDate',
    defaultMessage: 'Pay Date',
  },
  campaign: {
    id: 'app.common.tableHeaders.campaign',
    defaultMessage: 'Campaign',
  },
  campaigns: {
    id: 'app.common.tableHeaders.campaigns',
    defaultMessage: 'Campaigns',
  },
  type: {
    id: 'app.common.tableHeaders.type',
    defaultMessage: 'Type',
  },
  payment: {
    id: 'app.common.tableHeaders.payment',
    defaultMessage: 'Payment',
  },
  membership: {
    id: 'app.common.tableHeaders.membership',
    defaultMessage: 'Membership',
  },
  contactInformation: {
    id: 'app.common.tableHeaders.contactInformation',
    defaultMessage: 'Contact information',
  },
  lead: {
    id: 'app.common.tableHeaders.lead',
    defaultMessage: 'Lead',
  },
  ptLead: {
    id: 'app.common.tableHeaders.ptLead',
    defaultMessage: 'PT lead',
  },
  salesperson: {
    id: 'app.common.tableHeaders.salesperson',
    defaultMessage: 'Salesperson',
  },
  date: {
    id: 'app.common.tableHeaders.date',
    defaultMessage: 'Date',
  },
  addedDate: {
    id: 'app.common.tableHeaders.addedDate',
    defaultMessage: 'Added Date',
  },
  entrance: {
    id: 'app.common.tableHeaders.entrance',
    defaultMessage: 'Entrance',
  },
  address: {
    id: 'app.common.tableHeaders.address',
    defaultMessage: 'Address',
  },
  contactName: {
    id: 'app.common.tableHeaders.contactName',
    defaultMessage: 'Contact name',
  },
  script: {
    id: 'app.common.tableHeaders.script',
    defaultMessage: 'Script',
  },
  entities: {
    id: 'app.common.tableHeaders.entities',
    defaultMessage: 'Entities',
  },
  state: {
    id: 'app.common.tableHeaders.state',
    defaultMessage: 'state',
  },
  level: {
    id: 'app.common.tableHeaders.level',
    defaultMessage: 'Level',
  },
  open: {
    id: 'app.common.tableHeaders.open',
    defaultMessage: 'Open/Closed',
  },
  trigger: {
    id: 'app.common.tableHeaders.trigger',
    defaultMessage: 'trigger',
  },
  module: {
    id: 'app.common.tableHeaders.module',
    defaultMessage: 'module',
  },
  deliveryType: {
    id: 'app.common.tableHeaders.deliveryType',
    defaultMessage: 'delivery type',
  },
  jobPosition: {
    id: 'app.common.tableHeaders.jobPosition',
    defaultMessage: 'Job Position',
  },
  includedInventory: {
    id: 'app.common.tableHeaders.includedInventory',
    defaultMessage: 'Included inventory',
  },
  includedServices: {
    id: 'app.common.tableHeaders.includedServices',
    defaultMessage: 'Included services',
  },
  includedPackages: {
    id: 'app.common.tableHeaders.includedPackages',
    defaultMessage: 'Included bundles',
  },
  daysTimes: {
    id: 'app.common.tableHeaders.daysTimes',
    defaultMessage: 'Days & times',
  },
  size: {
    id: 'app.common.tableHeaders.size',
    defaultMessage: 'Size',
  },
  change: {
    id: 'app.common.tableHeaders.change',
    defaultMessage: 'Change',
  },
  changedBy: {
    id: 'app.common.tableHeaders.changedBy',
    defaultMessage: 'Changed by',
  },
  price: {
    id: 'app.common.tableHeaders.price',
    defaultMessage: 'Price',
  },
  reward: {
    id: 'app.common.tableHeaders.reward',
    defaultMessage: 'Reward',
  },
  documentNumber: {
    id: 'app.common.tableHeaders.documentNumber',
    defaultMessage: 'Document number',
  },
  checkOut: {
    id: 'app.common.tableHeaders.checkOut',
    defaultMessage: 'Check-out',
  },
  pickedUp: {
    id: 'app.common.tableHeaders.pickedUp',
    defaultMessage: 'Picked-up',
  },
  historyOfChanges: {
    id: 'app.common.tableHeaders.historyOfChanges',
    defaultMessage: 'History Of Changes',
  },
  pastValue: {
    id: 'app.common.tableHeaders.pastValue',
    defaultMessage: 'Past Value',
  },
  newValue: {
    id: 'app.common.tableHeaders.newValue',
    defaultMessage: 'New Value',
  },
  dropOff: {
    id: 'app.common.tableHeaders.dropOff',
    defaultMessage: 'Drop Off',
  },
  participants: {
    id: 'app.common.tableHeaders.participants',
    defaultMessage: 'Participants',
  },
  slots: {
    id: 'app.common.tableHeaders.slots',
    defaultMessage: 'Slots',
  },
  attended: {
    id: 'app.common.tableHeaders.attended',
    defaultMessage: 'Attended',
  },
  eventTag: {
    id: 'app.common.tableHeaders.eventTag',
    defaultMessage: 'Event Tag',
  },
  resources: {
    id: 'app.common.tableHeaders.resources',
    defaultMessage: 'Resources',
  },
  registersStatus: {
    id: 'app.common.tableHeaders.registersStatus',
    defaultMessage: 'Registers Status',
  },
  opened: {
    id: 'app.common.tableHeaders.opened',
    defaultMessage: 'Opened',
  },
  openedDate: {
    id: 'app.common.tableHeaders.openedDate',
    defaultMessage: 'Opened Date',
  },
  openedBy: {
    id: 'app.common.tableHeaders.openedBy',
    defaultMessage: 'Opened By',
  },
  opened$$$: {
    id: 'app.common.tableHeaders.opened$$$',
    defaultMessage: 'Opened $$$',
  },
  closed: {
    id: 'app.common.tableHeaders.closed',
    defaultMessage: 'Closed',
  },
  closedDate: {
    id: 'app.common.tableHeaders.closedDate',
    defaultMessage: 'Closed Date',
  },
  closedBy: {
    id: 'app.common.tableHeaders.closedBy',
    defaultMessage: 'Closed By',
  },
  closed$$$: {
    id: 'app.common.tableHeaders.closed$$$',
    defaultMessage: 'Closed $$$',
  },
  employeeOpened: {
    id: 'app.common.tableHeaders.employeeOpened',
    defaultMessage: 'Employee Opened',
  },
  clockIn: {
    id: 'app.common.tableHeaders.clockIn',
    defaultMessage: 'Clock In',
  },
  locked: {
    id: 'app.common.tableHeaders.locked',
    defaultMessage: 'Locked',
  },
  clockOut: {
    id: 'app.common.tableHeaders.clockOut',
    defaultMessage: 'Clock Out',
  },
  startingAmount: {
    id: 'app.common.tableHeaders.startingAmount',
    defaultMessage: 'Starting Amount',
  },
  employeeClosed: {
    id: 'app.common.tableHeaders.employeeClosed',
    defaultMessage: 'Employee Closed ',
  },
  private: {
    id: 'app.common.tableHeaders.private',
    defaultMessage: 'Private',
  },
  paid: {
    id: 'app.common.tableHeaders.paid',
    defaultMessage: 'Paid',
  },
  billOrCoin: {
    id: 'app.common.tableHeaders.billOrCoin',
    defaultMessage: 'Bill / Coin',
  },
  uploadDate: {
    id: 'app.common.tableHeaders.uploadDate',
    defaultMessage: 'Upload Date',
  },
  signedDate: {
    id: 'app.common.tableHeaders.signedDate',
    defaultMessage: 'Signed Date',
  },
  invoiceNumberShort: {
    id: 'app.common.tableHeaders.invoiceNumberShort',
    defaultMessage: 'Invoice #',
  },
  paymentMethod: {
    id: 'app.common.tableHeaders.paymentMethod',
    defaultMessage: 'Payment Method',
  },
  errorResponse: {
    id: 'app.common.tableHeaders.errorResponse',
    defaultMessage: 'Error Response',
  },
  response: {
    id: 'app.common.tableHeaders.response',
    defaultMessage: 'Response',
  },
  from: {
    id: 'app.common.tableHeaders.from',
    defaultMessage: 'from',
  },
  to: {
    id: 'app.common.tableHeaders.to',
    defaultMessage: 'to',
  },
  message: {
    id: 'app.common.tableHeaders.message',
    defaultMessage: 'message',
  },
  eventDescription: {
    id: 'app.common.tableHeaders.eventDescription',
    defaultMessage: 'Event Description',
  },
  publishedBy: {
    id: 'app.common.tableHeaders.publishedBy',
    defaultMessage: 'Published By',
  },
  action: {
    id: 'app.common.tableHeaders.Action',
    defaultMessage: 'Action',
  },
  image: {
    id: 'app.common.tableHeaders.image',
    defaultMessage: 'Image',
  },
  title: {
    id: 'app.common.tableHeaders.title',
    defaultMessage: 'Title',
  },
  body: {
    id: 'app.common.tableHeaders.body',
    defaultMessage: 'Body',
  },
  sentTo: {
    id: 'app.common.tableHeaders.sentTo',
    defaultMessage: 'Sent to',
  },
  willBeRemovedAfter: {
    id: 'app.common.tableHeaders.willBeRemovedAfter',
    defaultMessage: 'Will be removed after',
  },
  published: {
    id: 'app.common.tableHeaders.published',
    defaultMessage: 'Published',
  },
  pos: {
    id: 'app.common.tableHeaders.pos',
    defaultMessage: 'POS',
  },
  posFlat: {
    id: 'app.common.tableHeaders.posFlat',
    defaultMessage: 'POS $',
  },
  posPercentage: {
    id: 'app.common.tableHeaders.posPercentage',
    defaultMessage: 'POS %',
  },
  regular: {
    id: 'app.common.tableHeaders.regular',
    defaultMessage: 'Regular',
  },
  regularFlat: {
    id: 'app.common.tableHeaders.regularFlat',
    defaultMessage: 'Regular $',
  },
  regularPercentage: {
    id: 'app.common.tableHeaders.regularPercentage',
    defaultMessage: 'Regular %',
  },
  daySheetTableColType: {
    id: 'app.common.tableHeaders.daySheetTableColType',
    defaultMessage: 'Type',
  },
  daySheetTableColRange: {
    id: 'app.common.tableHeaders.daySheetTableColRange',
    defaultMessage: 'Range',
  },
  daySheetTableColNew: {
    id: 'app.common.tableHeaders.daySheetTableColNew',
    defaultMessage: 'New',
  },
  daySheetTableColR: {
    id: 'app.common.tableHeaders.daySheetTableColR',
    defaultMessage: 'R',
  },
  daySheetTableColS: {
    id: 'app.common.tableHeaders.daySheetTableColS',
    defaultMessage: 'S',
  },
  daySheetTableColM: {
    id: 'app.common.tableHeaders.daySheetTableColM',
    defaultMessage: 'M',
  },
  daySheetTableColUD: {
    id: 'app.common.tableHeaders.daySheetTableColUD',
    defaultMessage: 'U/D',
  },
  daySheetTableColGoal: {
    id: 'app.common.tableHeaders.daySheetTableColGoal',
    defaultMessage: 'Goal',
  },
  daySheetTableColPercent: {
    id: 'app.common.tableHeaders.daySheetTableColPercent',
    defaultMessage: '%',
  },
  daySheetTableColDraft: {
    id: 'app.common.tableHeaders.daySheetTableColDraft',
    defaultMessage: 'Draft',
  },
  daySheetTableColIf: {
    id: 'app.common.tableHeaders.daySheetTableColIf',
    defaultMessage: 'If',
  },
  daySheetTableColTsp: {
    id: 'app.common.tableHeaders.daySheetTableColTsp',
    defaultMessage: 'Tsp',
  },
  daySheetTableColCommission: {
    id: 'app.common.tableHeaders.daySheetTableColCommission',
    defaultMessage: 'Comm.',
  },
  daySheetTableColReferrals: {
    id: 'app.common.tableHeaders.daySheetTableColReferrals',
    defaultMessage: 'Referrals',
  },
  daySheetTableColAveragePerSale: {
    id: 'app.common.tableHeaders.daySheetTableColAveragePerSale',
    defaultMessage: 'Average per Sale',
  },
  daySheetTableColEvent: {
    id: 'app.common.tableHeaders.daySheetTableColEvent',
    defaultMessage: 'Event',
  },
  daySheetTableColCount: {
    id: 'app.common.tableHeaders.daySheetTableColCount',
    defaultMessage: 'Count',
  },
  daySheetTableColDayOfWeek: {
    id: 'app.common.tableHeaders.daySheetTableColDayOfWeek',
    defaultMessage: 'Day of Week',
  },
  daySheetTableColTop: {
    id: 'app.common.tableHeaders.daySheetTableColTop',
    defaultMessage: 'Top',
  },
  daySheetTableColName: {
    id: 'app.common.tableHeaders.daySheetTableColName',
    defaultMessage: 'Name',
  },
  daySheetTableColIcon: {
    id: 'app.common.tableHeaders.daySheetTableColIcon',
    defaultMessage: 'Icon',
  },
  daySheetTableColDescription: {
    id: 'app.common.tableHeaders.daySheetTableColDescription',
    defaultMessage: 'Description',
  },
  daySheetTableColEmp: {
    id: 'app.common.tableHeaders.daySheetTableColEmp',
    defaultMessage: 'Emp',
  },
  actionType: {
    id: 'app.common.tableHeaders.actionType',
    defaultMessage: 'Action type',
  },
  createdBy: {
    id: 'app.common.tableHeaders.createdBy',
    defaultMessage: 'created by',
  },
  createdAt: {
    id: 'app.common.tableHeaders.createdAt',
    defaultMessage: 'created at',
  },
  sellDate: {
    id: 'app.common.tableHeaders.sellDate',
    defaultMessage: 'sell date',
  },
  employeeId: {
    id: 'app.common.tableHeaders.employeeId',
    defaultMessage: 'Identifier',
  },
  finalization: {
    id: 'app.common.tableHeaders.finalization',
    defaultMessage: 'Finalization',
  },
  finalizedBy: {
    id: 'app.common.tableHeaders.finalizedBy',
    defaultMessage: 'Finalized By',
  },
  finalizedAt: {
    id: 'app.common.tableHeaders.finalizedAt',
    defaultMessage: 'Finalized At',
  },
  bank: {
    id: 'app.common.tableHeaders.bank',
    defaultMessage: 'Bank',
  },
  bankType: {
    id: 'app.common.tableHeaders.bankType',
    defaultMessage: 'Bank Type',
  },
  count: {
    id: 'app.common.tableHeaders.count',
    defaultMessage: 'Count',
  },
  memberNumber: {
    id: 'app.common.tableHeaders.memberNumber',
    defaultMessage: 'Member number',
  },
  billed: {
    id: 'app.common.tableHeaders.billed',
    defaultMessage: 'Billed',
  },
  asanaTask: {
    id: 'app.common.tableHeaders.asanaTask',
    defaultMessage: 'Asana Task',
  },
  updatedAt: {
    id: 'app.common.tableHeaders.updatedAt',
    defaultMessage: 'Updated At',
  },
  systemCode: {
    id: 'app.common.tableHeaders.systemCode',
    defaultMessage: 'system Code',
  },
  transactionType: {
    id: 'app.common.tableHeaders.transactionType',
    defaultMessage: 'Transaction Type',
  },
  processType: {
    id: 'app.common.tableHeaders.processType',
    defaultMessage: 'Process Type',
  },
  revenueCode: {
    id: 'app.common.tableHeaders.revenueCode',
    defaultMessage: 'Revenue Code',
  },
  text: {
    id: 'app.common.tableHeaders.text',
    defaultMessage: 'Text',
  },
  alertAtNextCheckIn: {
    id: 'app.common.tableHeaders.alertAtNextCheckIn',
    defaultMessage: 'Alert At Next Check In',
  },
  noteCode: {
    id: 'app.common.tableHeaders.noteCode',
    defaultMessage: 'Note Code',
  },
  createdDate: {
    id: 'app.common.tableHeaders.createdDate',
    defaultMessage: 'Created Date',
  },
  transactionDate: {
    id: 'app.common.tableHeaders.transactionDate',
    defaultMessage: 'Transaction date',
  },
  peakPayment: {
    id: 'app.common.tableHeaders.peakPayment',
    defaultMessage: 'Peak payment',
  },
  voidInfo: {
    id: 'app.common.tableHeaders.voidInfo',
    defaultMessage: 'Void info',
  },
  ref: {
    id: 'app.common.tableHeaders.ref',
    defaultMessage: 'REF.',
  },
  charge: {
    id: 'app.common.tableHeaders.charge',
    defaultMessage: 'Charge',
  },
});
